import { IconButton } from '@mui/material';

import Tooltip from 'common/components/tooltip';
import { saveFile } from 'common/utils/files';
import * as icons from 'images/icons/attachments';
import { ReactComponent as DownloadButton } from 'images/icons/downloadThumbnailIcon.svg';
import { ReactComponent as Trash } from 'images/icons/trashIcon.svg';
import { useGeneratedPresignedUrlByAttachmentId } from 'remote-state/attachments';

import { StyledAttachmentChip, StyledAttachmentChipWrapper } from './StyledAttachmentChip';
import { fileIcon } from './attachmentIcons';
import DeleteButton from '../deleteAttachment';

export const AttachmentChip = (props) => {
  const {
    attachmentId,
    extension,
    originalName,
    isDeleted,
    isReadOnly,
    isDownloaded,
    shouldTriggerDeleteApi,
    onAttachmentDeleted,
    deleteAttachmentEnabled,
  } = props;
  const icon = fileIcon(extension);
  const { data: { url } } = useGeneratedPresignedUrlByAttachmentId({ attachmentId });

  const deleteButton = (
    <DeleteButton
      attachmentId={attachmentId}
      fileName={originalName}
      onAttachmentDeleted={onAttachmentDeleted}
      shouldTriggerDeleteApi={shouldTriggerDeleteApi}
      data-cy={`attachment-uploader-chip-delete-button-${attachmentId}`}
    >
      <Trash />
    </DeleteButton>
  );

  const chip = (
    <StyledAttachmentChipWrapper data-cy={`attachment-uploader-chip-${attachmentId}`}>
      <StyledAttachmentChip className="attachment-chip" isDisabled={isDeleted}>
        <img className="attachment-icon" alt="" src={icons[icon]} />
        <Tooltip
          isTruncatedText
          title={originalName}
          data-cy={`attachment-uploader-chip-title-${attachmentId}`}
          text={originalName}
          placement="top"
        />
        {isReadOnly && !isDeleted && !isDownloaded && (
          <div className="icons-wrapper">
            <IconButton
              data-testid="download-button"
              data-cy={`attachment-uploader-chip-download-button-${attachmentId}`}
              onClick={() => saveFile({ url, fileName: originalName })}
            >
              <DownloadButton />
            </IconButton>
            {deleteAttachmentEnabled && deleteButton}
          </div>
        )}
      </StyledAttachmentChip>
      {!isReadOnly && <div className="icons-wrapper">{deleteAttachmentEnabled && deleteButton}</div>}
    </StyledAttachmentChipWrapper>
  );

  return chip;
};
